const { CSInterface } = window as any;
const csInterface = new CSInterface();

export function runEvalScript(script: string) {
  return new Promise(function (resolve, reject) {
    csInterface.evalScript(script, (data: string) => {
      try {        
        const res = JSON.parse(data);
        resolve(res);
      } catch (err) {
        reject(err);
      }
    });
  });
}
